
import React, { useState } from 'react'
import { Link } from 'react-router-dom';




import './Header.css'
import MobileMenu from '../../components/MobileMenu/MobileMenu';


interface ChildProps {
   page: number;
   updatePage: any;

}

const Header: React.FC<ChildProps> = (props) => {


   const [icon, setIcon] = useState(0);


   function clicd(a: any) {
      setIcon(a)
      props.updatePage(a)

   }


   return (
      <div className="container navbar_container " style={{ paddingTop: '20px' }} >
         <div className="row navbar_row"  >
            {/* <div className="col-sm box_logo">
               <img src="./img/header/logo.png" alt="" />
            </div> */}
            <div className="col-sm details">
               <ul className="navbar_ul">
                  <Link to='./main'>
                     <li onClick={() => clicd(1)} >
                        <button title='main' className={icon === 1 ? 'btn_header_menu_click' : 'btn_header_menu'} ><img style={{ width: '91%' }} src='/img/header/home5.png' alt="home" /></button>
                     </li>
                  </Link>
                  <Link to='./info'>
                     <li onClick={() => clicd(2)}>
                        <button title='info' className={icon === 2 ? 'btn_header_menu_click' : 'btn_header_menu'} ><img style={{ width: '91%' }} src='/img/header/battle.png' alt="battle" /></button>
                     </li>
                  </Link>
                  <Link to='./stat'>
                     <li onClick={() => clicd(3)}>
                        <button title='statistics' className={icon === 3 ? 'btn_header_menu_click' : 'btn_header_menu'} ><img style={{ width: '91%' }} src='/img/header/stat.png' alt="stat" /></button>
                     </li>
                  </Link>
                  <Link to='./note'>
                     <li onClick={() => clicd(4)}>
                        <button title='FAQ' className={icon === 4 ? 'btn_header_menu_click' : 'btn_header_menu'} ><img style={{ width: '91%' }} src='/img/header/faq2.png' alt="faq" /></button>
                     </li>
                  </Link>
                  <Link to='./archive'>
                     <li onClick={() => clicd(5)}>
                        <button title='archive' className={icon === 5 ? 'btn_header_menu_click' : 'btn_header_menu'} ><img style={{ width: '91%' }} src='/img/header/archive.png' alt="faq" /></button>
                     </li>
                  </Link>
               </ul>

            </div>
         </div>
         {/* Мобильное меню */}
         <div className='mobile_menu_box'>
            <MobileMenu />
         </div>
      </div>
   )
}

export default Header;